<template>
  <div class="row map-container no-print">
    <div class="col-12 mb-3">
      <GoogleMap
        ref="map_ref"
        api-key="AIzaSyC2nwmesDNYChq5aFblDMqN1dnv_2q48iM"
        style="width: 100%; height: 500px"
        map-type-id="satellite"
        :center="map_center"
        :zoom="map_zoom"
        :fit-bounds="{}"
        @click="setNewPositionMarker"
      >
        <Marker
          v-for="map_marker in map_markers"
          :key="map_marker.id"
          :options="map_marker"
          @click="selectMarker(map_marker)"
        />
      </GoogleMap>
    </div>
  </div>
  <div class="to-map btn btn-secondary no-print">Voltar ao mapa</div>
</template>

<script>
  import { ref, watchEffect } from 'vue'
  import { GoogleMap, Marker } from 'vue3-google-map'
  import { format, parse as parseDate, compareAsc } from 'date-fns'
  import useMachines from '@/modules/Machine.js'
  import useSwal from '@/modules/Swal.js'
  import $ from 'jquery'

  export default {
    components: {
      GoogleMap,
      Marker,
    },
    setup() {
      const loading = ref(true)
      const map_ref = ref(null)
      const map_center = { lat: -13.70576, lng: -69.6477 }
      const map_zoom = 4
      const map_markers = ref([])
      const marker_selected = null
      const { showSuccessDialog, showErrorDialog, showConfirmationDialog } =
        useSwal()
      const { filtered_machines } = useMachines()

      watchEffect(() => {
        if (map_ref.value?.ready) {
          var bounds = new map_ref.value.api.LatLngBounds()

          filtered_machines.value.map((machine) => {
            // Mostra só a posição mais recente de cada equipamento — não todo o
            // histórico de risk_analyses (que inclui coletas antigas e dados
            // migrados do sistema legado, sem relação com a foto atual do
            // equipamento). "Mais recente" = maior id (auto-incremento).
            const valid_analyses = (machine?.risk_analyses || []).filter((risk_analysis) => {
              return (
                risk_analysis?.latitude &&
                risk_analysis?.longitude &&
                risk_analysis.latitude != '' &&
                risk_analysis.latitude != '.0000000000'
              )
            })

            if (valid_analyses.length === 0) return

            const risk_analysis = valid_analyses.reduce((latest, current) => {
              return current.id > latest.id ? current : latest
            })

            bounds.extend(
              new map_ref.value.api.LatLng(
                risk_analysis.latitude,
                risk_analysis.longitude,
              ),
            )

            const equals = map_markers.value.filter(marker => {
              marker = JSON.parse(JSON.stringify(marker))
              const lat = marker.position.lat
              const lng = marker.position.lng
              return lat == risk_analysis.latitude && lng == risk_analysis.longitude
            })

            if (equals.length == 0) {
              map_markers.value.push({
                id: risk_analysis.id,
                position: {
                  lat: parseFloat(risk_analysis.latitude),
                  lng: parseFloat(risk_analysis.longitude),
                },
                label: '1',
                title: `Tag Ambra: ${
                  machine?.ambra_tag || '-'
                }\nTag Equip.: ${machine?.machine_tag || '-'}`,
              })
            } else {
              const marker = equals[0]
              marker.title += `\n\nTag Ambra: ${
                  machine?.ambra_tag || '-'
              }\nTag Equip.: ${machine?.machine_tag || '-'}`
              marker.label = `${parseInt(marker.label) + 1}`
            }
          })

          map_ref.value.map.fitBounds(bounds)
          map_ref.value.map.panToBounds(bounds)

          loading.value = false
        }
      })

      return {
        loading,
        map_ref,
        map_center,
        map_zoom,
        map_markers,
        showSuccessDialog,
        showErrorDialog,
        showConfirmationDialog,
        marker_selected,
      }
    },
    methods: {
      selectMarker(marker) {
        this.marker_selected = {
          id: marker.id,
          created_at: format(new Date(), 'dd/MM/yyyy H:m:s'),
        }
        localStorage.setItem(
          'selected_marker_map',
          JSON.stringify(this.marker_selected),
        )
      },
      selectedFirstMachine() {
        const map = JSON.parse(localStorage.getItem('selected_marker_map'))
        const table = JSON.parse(localStorage.getItem('selected_machine_table'))

        if (!table && map) {
          return map
        } else if (!map && table) {
          return table
        } else if (map && table) {
          const dateMap = parseDate(
            map.created_at,
            'dd/MM/yyyy H:m:s',
            new Date(),
          )
          const tableMap = parseDate(
            table.created_at,
            'dd/MM/yyyy H:m:s',
            new Date(),
          )

          if (compareAsc(dateMap, tableMap)) {
            return map
          }

          return table
        }

        return null
      },
      setNewPositionMarker(event) {
        this.marker_selected = this.selectedFirstMachine()

        if (this.marker_selected) {
          const data = {
            id: this.marker_selected.id,
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          }

          this.showConfirmationDialog(
            'Tem certeza desta operação?',
            'Esta ação irá alterar a localização do equipamento.',
            'warning',
          ).then((response) => {
            if (response) {
              this.axios
                .post('/api/geo', data)
                .then((res) => {
                  if (res) {
                    this.map_markers.map((item, index) => {
                      if (item.id === res.id) {
                        this.map_markers[index].position.lat = res.latitude
                        this.map_markers[index].position.lng = res.longitude
                      }
                    })

                    this.showSuccessDialog()

                    setTimeout(() => {
                      location.reload()
                    }, 1500)
                  }
                })
                .catch((error) => {
                  if (error) {
                    this.showErrorDialog(`
                      <small style="color:red">${error.message}</small>
                    `)
                  }
                })

              localStorage.removeItem('selected_marker_map')
              localStorage.removeItem('selected_machine_table')
            }
          })
        }
      },
      backToMap() {
        $('.to-map').click(function () {
          $('html, body').animate(
            {
              scrollTop: $('.map-container').offset().top - 50,
            },
            500,
          )
        })
      },
    },
    mounted() {
      localStorage.removeItem('selected_marker_map')
      localStorage.removeItem('selected_machine_table')

      this.backToMap()
    },
  }
</script>
